import UserNotificationsDB from 'src/fb/userNotifications-db';
import { bindDataBaseStore, unbindDataBaseStore } from 'src/utils/FirestoreUtils';

export default {

  async loadNewNotificationsCount({ userId, disabledRequiredActions }) {
    const userNotificationsDb = new UserNotificationsDB();
    const actionNotificationsQuery = userNotificationsDb.getQuery([
      ['user', '==', userId],
      ['hasAction', '==', true],
      ['actionCompleted', '==', false],
      ...(disabledRequiredActions.length ? [['type', 'not-in', disabledRequiredActions]] : []),
    ]);
    const nonActionNotificationsQuery = userNotificationsDb.getQuery([
      ['user', '==', userId],
      ['hasAction', '==', false],
      ['viewed', '==', false],
    ]);

    const [actionNotificationsCount, nonActionNotificationsCount] = await Promise.all([
      userNotificationsDb.countRecords(actionNotificationsQuery),
      userNotificationsDb.countRecords(nonActionNotificationsQuery),
    ]);

    const notificationsCount = +actionNotificationsCount + +nonActionNotificationsCount;

    this.setUserNotificationsCount(notificationsCount);
    this.setActionNotificationsCount(actionNotificationsCount);
  }, // loadNewNotificationsCount()

  setUserNotificationsCount(count) {
    this.userNotificationsCount = count;
  }, // setUserNotificationsCount()

  setActionNotificationsCount(count) {
    this.userActionNotificationsCount = count;
  }, // setActionNotificationsCount()

  async bindUserNotifications({ userId, disabledRequiredActions }) {
    const userNotificationsDb = new UserNotificationsDB();
    const actionNotificationsQuery = userNotificationsDb.getQuery(
      [
        ['user', '==', userId],
        ['hasAction', '==', true],
        ['actionCompleted', '==', false],
        ...(disabledRequiredActions.length ? [['type', 'not-in', disabledRequiredActions]] : []),
      ],
      'createTimestamp',
      'desc',
      5,
    );
    const nonActionNotificationsQuery = userNotificationsDb.getQuery(
      [
        ['user', '==', userId],
        ['hasAction', '==', false],
        ['viewed', '==', false],
      ],
      'createTimestamp',
      'desc',
      5,
    );

    return Promise.all([
      bindDataBaseStore({ store: this, property: 'userActionNotifications' }, actionNotificationsQuery, []),
      bindDataBaseStore({ store: this, property: 'userNonActionNotifications' }, nonActionNotificationsQuery, []),
    ]);
  }, // bindUserNotifications()

  unbindUserNotifications() {
    unbindDataBaseStore({ store: this, property: 'userActionNotifications' }, []);
    unbindDataBaseStore({ store: this, property: 'userNonActionNotifications' }, []);
  }, // unbindUserNotifications()

  async rebindUserActionNotifications({ userId, disabledRequiredActions }) {
    const userNotificationsDb = new UserNotificationsDB();
    const actionNotificationsQuery = userNotificationsDb.getQuery(
      [
        ['user', '==', userId],
        ['hasAction', '==', true],
        ['actionCompleted', '==', false],
        ...(disabledRequiredActions.length ? [['type', 'not-in', disabledRequiredActions]] : []),
      ],
      'createTimestamp',
      'desc',
      5,
    );

    await unbindDataBaseStore({ store: this, property: 'userActionNotifications' }, []);
    return bindDataBaseStore({ store: this, property: 'userActionNotifications' }, actionNotificationsQuery, []);
  }, // rebindUserActionNotifications()

  logout() {
    this.unbindUserNotifications();
  }, // logout()

};
